import { ModuleFE_Value } from './ModuleFE_Value.js';
export const ModulePackFE_Value = [ModuleFE_Value];
//# sourceMappingURL=module-pack.js.map